import { createRouter, createWebHistory } from 'vue-router'

import LandingPage from '@/views/landing_page/landing_page.vue'

// Settings
import Settings from '@/views/settings/settings.vue'
import AccountSettings from '@/views/settings/personal_information/account_settings.vue'
import ManagePayments from '@/views/settings/personal_information/manage_payments.vue'
import SavedLocations from '@/views/settings/personal_information/saved_locations.vue'
import NotificationSettings from '@/views/settings/notification_settings/notification_settings.vue'
import Orders from '@/views/settings/personal_information/orders.vue'
import QuoteHistory from '@/views/settings/personal_information/quote_history.vue'

// Service Providers
import ServiceProviders from '@/views/service_providers/service_providers.vue'
import SearchResultsPage from '@/views/service_providers/search_results_page.vue'
import ServiceProviderProfilePage from '@/views/service_providers/service_provider_profile_page.vue'

// Blitz a Quote
import RequestAQuote from '@/views/request_a_quote/request_a_quote.vue'

// My Garage
import MyGarage from '@/views/my_garage/my_garage.vue'
import VehicleProfileTab from '@/views/my_garage/pages/vehicle_profile_tab.vue'
import ServiceTab from '@/views/my_garage/pages/service_tab.vue'
import Quote from '@/views/my_garage/pages/quote.vue'
import Activation from '@/views/activation/activation.vue'
import PasswordReset from '@/views/password-reset/password-reset.vue'
import AllQuotes from '@/views/my_garage/all_quotes.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
        title: 'Home'
      }
    },
    {
      path: '/activate',
      name: 'Activation',
      component: Activation,
      meta: {
        title: 'Activate'
      }
    },
    {
      path: '/password-reset',
      name: 'PasswordReset',
      component: PasswordReset,
      meta: {
        title: 'Password Reset'
      }
    },
    {
      path: '/settings',
      component: Settings,
      meta: {
        title: 'Settings'
      },
      children: [
        {
          path: 'account',
          components: {
            mainContent: AccountSettings
          },
          meta: {
            title: 'Account Settings'
          }
        },
        {
          path: 'manage_payments',
          components: {
            mainContent: ManagePayments
          },
          meta: {
            title: 'Manage Payments'
          }
        },
        {
          path: 'saved_locations',
          components: {
            mainContent: SavedLocations
          },
          meta: {
            title: 'Saved Locations'
          }
        },
        {
          path: 'notification_settings',
          components: {
            mainContent: NotificationSettings
          },
          meta: {
            title: 'Notification Settings'
          }
        },
        {
          path: 'orders',
          components: {
            mainContent: Orders
          },
          meta: {
            title: 'Orders'
          }
        },
        {
          path: 'quote_history',
          components: {
            mainContent: QuoteHistory
          },
          meta: {
            title: 'Quote History'
          }
        }
      ]
    },
    {
      name: 'service_provider.service_provider',
      path: '/service_providers',
      redirect: '/service_providers/search_results',
      component: ServiceProviders,
      meta: {
        title: 'Service Providers'
      },
      children: [
        {
          name: 'service_provider.search_results',
          path: 'search_results',
          component: SearchResultsPage
        },
        {
          name: 'service_provider.profile',
          path: ':id',
          component: ServiceProviderProfilePage
        }
      ]
    },
    {
      path: '/request_a_quote/step/:step',
      name: 'RequestAQuote',
      component: RequestAQuote,
      meta: {
        title: 'Request a Quote'
      }
    },
    {
      name: 'my_garage.my_garage',
      path: '/my_garage',
      redirect: '/my_garage/vehicle_profile',
      component: MyGarage,
      meta: {
        title: 'My Garage'
      },
      children: [
        {
          name: 'my_garage.vehicle_profile',
          path: 'vehicle_profile',
          component: VehicleProfileTab
        },
        {
          name: 'my_garage.service',
          path: 'service',
          component: ServiceTab
        },
        {
          name: 'my_garage.quote',
          path: 'quote/:id',
          component: Quote
        }
      ]
    },
    {
      name: 'all_quotes',
      path: '/quote/:id',
      component: AllQuotes
    }
  ]
})

const getBaseTitle = () => {
  return `AutoWise${!import.meta.env.PROD ? ' (' + import.meta.env.VITE_APP_ENV + ')' : ''}`
}

router.beforeEach((to, from, next) => {
  document.title = `${getBaseTitle()}${to.meta.title ? ' - ' + to.meta.title : ''}`

  // Don't scroll to top when navigating between quotes on the same page
  if (!(to.name === 'my_garage.quote' && from.name === 'my_garage.quote')) {
    window.scrollTo(0, 0)
  }
  next()
})

export default router
